import React from 'react';
import PropTypes from 'prop-types';
import CoachingAgendaCard from 'components/dashboard/CoachingAgendaCard';
import {List} from 'immutable';
import User from 'records/User';
import AgendaColumnHeader from 'components/dashboard/AgendaColumnHeader';
import {CoachingReviewTypeDisplayAndChooser} from 'components/dashboard/common/CoachingReviewTypeDisplayAndChooser';
import NoUpcomingReviewsReady from 'components/dashboard/NoUpcomingReviewsReady';
import AgendaStartOrContinueMeetingButton from 'components/dashboard/AgendaStartOrContinueMeetingButton';

/**
 * Column containing reviews that are ready to start.
 *
 * See CoachingAgenda.styl for styling.
 */
export default class UpcomingAgendaColumn extends React.PureComponent {
  render() {
    const {reviews, reviewTypes, plans, sessionUser, selectedPlanId} = this.props;
    const popoverMessage =
      'These coaching meetings are ready to take place according to the' +
      ' pre-set schedule of the Coaching Plan. All review preparation for these coaching meetings' +
      ' has been completed. ';
    return (
      <div className="upcoming-column agenda-column">
        <AgendaColumnHeader popoverMessage={popoverMessage} title="Upcoming Coaching Activity" />
        {reviews.isEmpty() ? (
          <NoUpcomingReviewsReady sessionUser={sessionUser} />
        ) : (
          reviews.map(r => {
            return (
              <CoachingAgendaCard
                key={r.id}
                className={selectedPlanId === r.planId ? 'selected blink' : ''}
                rep={r.coachingPlan?.recipient.info}
                pendingType="READY"
                onEditPlan={this.props.onEditPlan}
                refreshCoachingData={this.props.refreshCoachingData}
                review={r}
                plans={plans}>
                <div>
                  {!r.coachingPlan?.adHoc && (
                    <CoachingReviewTypeDisplayAndChooser
                      review={r}
                      reviewTypes={reviewTypes}
                      onSetReviewType={this.props.onSetReviewType}
                    />
                  )}
                  <AgendaStartOrContinueMeetingButton review={r} />
                </div>
              </CoachingAgendaCard>
            );
          })
        )}
      </div>
    );
  }
}

UpcomingAgendaColumn.propTypes = {
  sessionUser: PropTypes.instanceOf(User),
  reviews: PropTypes.instanceOf(List), // List<CoachingReview>
};
